import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.999 1.332a6.667 6.667 0 1 1-.001 13.334 6.667 6.667 0 0 1 .001-13.334m2.481 4.186a.667.667 0 0 0-.943 0l-2.88 2.881V6.883a.667.667 0 0 0-1.335 0v3.126a.67.67 0 0 0 .667.667h3.126a.667.667 0 0 0 0-1.334H7.6L10.48 6.46a.667.667 0 0 0 0-.943"
    }, null, -1)
  ])))
}
export default { render: render }